<div class="file-previewer">
  <modal-title [title]="'filePreview' | translate" />

  <mat-dialog-content>
    <div class="iframe">
      <video *ngIf="data.isVideo" controls playsinline preload="metadata" [src]="src"></video>
      <ngx-extended-pdf-viewer *ngIf="data.isPDF" [src]="src" useBrowserLocale="true" height="100%" />
      <iframe *ngIf="!data.isPDF && !data.isVideo" width="100%" (load)="load()" [src]="src"></iframe>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="mt-2">
    <app-button
      [class]="'bold py-2 px-3 mr-3'"
      (onClick)="dialogRef.close()"
      [config]="{
        size: ButtonSize.LARGE,
        type: ButtonTypes.NEW_SECONDARY_BLUE,
        text: 'cancel' | translate
      }"
    />
    <app-button
      [class]="'bold py-2 px-3'"
      [loading]="downloading"
      [disabled]="downloading"
      (onClick)="data?.downloadFunc()"
      [config]="{
        size: ButtonSize.LARGE,
        type: ButtonTypes.NEW_PRIMARY_BLUE,
        text: 'download' | translate,
        prependSrc: '/assets/img/ic-download-outline.svg'
      }"
    />
  </mat-dialog-actions>
</div>
